export const getPluralForm = (quantity, type) => {
  if (quantity <= 1) return type;

  switch (type) {
    case "Box":
      return "Boxes";
    case "Bundle":
      return "Bundles";
    case 'Bucket':
      return "Buckets";
    case "Crate":
      return "Crates";
    case "Container":
      return "Containers";
    case "Envelope":
      return "Envelopes";
    case "Lift Van":
      return "Lift Vans";
    case "Standard Pallet":
      return "Standard Pallets";
    case "Straight Truck":
      return "Straight Trucks";
    case "Oversized Pallet":
      return "Oversized Pallets";
    case "TWC":
      return "TWCs";
    case "Roll":
      return "Rolls";
    case "Piece":
      return "Pieces";
    case "Miscellaneous":
      return "Miscellaneous";
    case "Tractor Trailer":
      return "Tractor Trailers";
    case "Vault":
      return "Vaults";
    default:
      return type;
  }
};

export default function getTotalReceivingUnitsLabel(list) {
  // shipments.total_pieces is a JSON column whose DB default is {} — shipments
  // created outside the wizard (imports, factories) carry that instead of the
  // array the wizard writes, and a bare .map here unmounts the whole app.
  if (!Array.isArray(list)) return "";

  return list.map(v => `${v.received} ${getPluralForm(v.received, v.shipment_type)}`).join(", ");
}
